import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { resetForm, updateForm } from "@/redux/slices/formSlice";
import { REQUIRED_PAYMENT_METHOD_FIELDS } from "@/utils/constants";

export const useDynamicForm = () => {
  const dispatch = useAppDispatch();
  const formData = useAppSelector((state) => state.form.formData);
  return {
    updateFormData: useCallback(
      (
        formId: string,
        formData: Record<string, string | boolean | string[] | undefined>
      ) => {
        dispatch(updateForm({ formId, formData }));
      },
      [dispatch]
    ),
    getFormData: (formId: string) => {
      const data = formData[formId];
      if (!data) return data;

      const { isValid: _isValid, ...rest } = data;
      return rest;
    },
    getIsValid: (formId: string) => {
      const form = formData[formId];

      if (
        typeof form === "object" &&
        form !== null &&
        Object.keys(form).some((key) =>
          REQUIRED_PAYMENT_METHOD_FIELDS.includes(key)
        )
      ) {
        if ("isValid" in form) return form.isValid;
        return form;
      }

      // Some PSPs do not have a form, they are valid
      const isValid = form ?? true;

      return isValid;
    },
    resetForm: useCallback(() => {
      dispatch(resetForm());
    }, [dispatch]),
  };
};
